import { useContext, useState } from "react";
import { BoardContext, TeamContext } from "../../../../context";
import { Phase } from "../../../../util/enums";

const MuteButton = () => {
    const { game } = useContext(TeamContext);
    const { 
        soundVolume,
        setSoundVolume 
    } = useContext(BoardContext);
    const [removeButtonAfterFirstClick, setRemoveButtonAfterFirstClick] = useState<boolean>(false);

    const muteUmuteTheSound = () => {
		if (soundVolume) 
			setSoundVolume(0);

		if (!soundVolume)
			setSoundVolume(0.07);
	}

    const muteElevatorMusic = () => {
        if (soundVolume) {
			setSoundVolume(0);
            setRemoveButtonAfterFirstClick(true)
        }
    }

    if (removeButtonAfterFirstClick) 
        return <div></div>

    if (!game && soundVolume > 0) {
        return <div className="post_game_mute_button_positioning">
            <div className="mute_button_wrapper">
                <div className={`mute_button ${soundVolume ? "mute_button_unmuted_image" : "mute_button_muted_image"} `} onClick={() => muteElevatorMusic()}></div>
            </div>
        </div>
    }

    if (game)    
        return (
            <div className={`${game?.phase === Phase.SLOT_MACHINE ? "slotmachine_mute_button_positioning" : "board_mute_button_positioning" }`}>
                <div className="mute_button_wrapper">
                    <div className={`mute_button ${soundVolume ? "mute_button_unmuted_image" : "mute_button_muted_image"} `} onClick={() => muteUmuteTheSound()}></div>
                </div>
            </div>
        )
    
    return <div></div>
}

export default MuteButton;